import CaptchaSheet from "./CaptchaSheet";

export default {
    install(Vue) {
        Vue.component("a-captcha-sheet", CaptchaSheet);
    }
}
